import { render, staticRenderFns } from "./UserCRUD.vue?vue&type=template&id=0cb6b2fb&scoped=true&"
import script from "./UserCRUD.vue?vue&type=script&lang=js&"
export * from "./UserCRUD.vue?vue&type=script&lang=js&"
import style0 from "./UserCRUD.vue?vue&type=style&index=0&id=0cb6b2fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6b2fb",
  null
  
)

export default component.exports